import { getField, updateField } from 'vuex-map-fields';
import { types } from './mutation-types';

function getDefaultState() {
  return {
    comment: '',
    additionalFvInfo: '',
    deliveryDate: '',
    chargeDate: '',
    chargeTime: '',
    isRegulationChecked: false,
    isMarketingMailAgreementChecked: false,
    isMarketingPhoneAgreementChecked: false,
    isProfileAgreementChecked: false,
    isEvoucherPartnerAgreementChecked: false,
    isWithdrawalAgreementChecked: false,
    isVirtualCardDataOwnershipChecked: false,
    distribution: null,
  };
}

export const additionalInfo = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    distribution: state => state.distribution,
  },
  mutations: {
    updateField,
    [types.SET_STATE](state, { name, value }) {
      state[name] = value;
    },
    [types.SET_ORDER_COMMENT](state, newComment) {
      state.comment = newComment;
    },
    [types.SET_ADDITIONAL_FV_INFO](state, newComment) {
      state.additionalFvInfo = newComment;
    },
    [types.SET_DELIVERY_DATE](state, newDate) {
      state.deliveryDate = newDate;
    },
    [types.SET_CHARGE_DATE](state, newDate) {
      state.chargeDate = newDate;
    },
    [types.SET_DISTRIBUTION](state, newDistribution) {
      state.distribution = newDistribution;
    },
    [types.RESET_DANGEROUS_FIELDS](state) {
      const newState = getDefaultState();
      newState.distribution = state.distribution;
      Object.assign(state, newState);
    },
    [types.HYDRATE](state, payload = {}) {
      Object.assign(state, getDefaultState(), payload);
    },
  },
  actions: {
    handleStateChange({ commit }, payload) {
      commit(types.SET_STATE, payload);
    },
    handleCommentChange({ commit }, newComment) {
      commit(types.SET_ORDER_COMMENT, newComment);
    },
    handleAdditionalFvInfoChange({ commit }, newComment) {
      commit(types.SET_ADDITIONAL_FV_INFO, newComment);
    },
    handlePickDeliveryDate({ commit }, newDate) {
      commit(types.SET_DELIVERY_DATE, newDate);
    },
    handlePickChargeDate({ commit }, newDate) {
      commit(types.SET_CHARGE_DATE, newDate);
    },
    handleDistributionChange({ commit }, newDistribution) {
      commit(types.SET_DISTRIBUTION, newDistribution);
    },
    hydrate({ commit }, state) {
      commit(types.HYDRATE, state);
    },
    resetDangerousFields({ commit }) {
      commit(types.RESET_DANGEROUS_FIELDS);
    },
  },
};
